import Vue from 'vue';
import Router from 'vue-router';
import { MessageBox } from 'element-ui';

import store from '@/store';
import { setUnauthorizedHandler } from '@/api/client';

Vue.use(Router);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/LoginPage.vue'),
    meta: {
      guestOnly: true,
      title: '登录'
    }
  },
  {
    path: '/',
    component: () => import('@/layouts/AdminLayout.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: '',
        redirect: '/dashboard'
      },
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/dashboard/WelcomePage.vue'),
        meta: {
          title: '工作台'
        }
      },
      {
        path: '/role-control/list',
        name: 'role-list',
        component: () => import('@/views/roles/RoleListPage.vue'),
        meta: {
          title: '角色列表'
        }
      },
      {
        path: '/user-control/list',
        name: 'user-list',
        component: () => import('@/views/users/UserListPage.vue'),
        meta: {
          title: '管理员列表'
        }
      },
      {
        path: '/setting/system',
        name: 'system-setting',
        component: () => import('@/views/settings/SystemSettingPage.vue'),
        meta: {
          title: '基础设置'
        }
      },
      {
        path: '/tea-setting/list',
        name: 'tea-list',
        component: () => import('@/views/tea/TeaListPage.vue'),
        meta: {
          title: '茶类列表'
        }
      },
      {
        path: '/brew-setting/list',
        name: 'brew-setting',
        component: () => import('@/views/brew/BrewSettingPage.vue'),
        meta: {
          title: '冲泡配置'
        }
      },
      {
        path: '/feedback/list',
        name: 'feedback-list',
        component: () => import('@/views/feedback/FeedbackListPage.vue'),
        meta: {
          title: '建议列表'
        }
      },
      {
        path: '/user/list',
        name: 'member-list',
        component: () => import('@/views/app-users/AppUserListPage.vue'),
        meta: {
          title: '用户列表'
        }
      },
      {
        path: '/soak/list',
        name: 'soak-list',
        component: () => import('@/views/soak/SoakListPage.vue'),
        meta: {
          title: '泡法列表'
        }
      }
    ]
  }
];

const router = new Router({
  mode: 'hash',
  routes
});

setUnauthorizedHandler(async () => {
  if (router.currentRoute.path !== '/login') {
    await store.dispatch('auth/logout');
    await MessageBox.alert('登录失效，请重新登录', '提示', {
      confirmButtonText: '确定'
    });
    router.replace('/login');
  }
});

router.beforeEach(async (to, from, next) => {
  const token = store.state.auth.token;

  if (!token) {
    await store.dispatch('auth/bootstrap');
  }

  const hasToken = Boolean(store.state.auth.token);

  if (to.matched.some(record => record.meta.requiresAuth) && !hasToken) {
    next('/login');
    return;
  }

  if (to.meta.guestOnly && hasToken) {
    next('/dashboard');
    return;
  }

  next();
});

export default router;
